import React, { PureComponent } from 'react'
import Modal from 'src/components/Modal'
import SvgIcon from 'src/components/SvgIcon'

import styles from './styles.module.less'
import { isIos, isInStandaloneMode, getBodyContainer, getIconFromGraphics } from 'src/utils/helpers'
import { FormattedMessage } from 'react-intl'

class AddToHomeScreen extends PureComponent {
  state = {
    visible: false
  }

  componentDidMount() {
    const { isAddToHomeScreenClosed } = this.props

    if (isIos() && !isInStandaloneMode() && !isAddToHomeScreenClosed) {
      setTimeout(() => this.setState({ visible: true }), 4000)
    }
  }

  closeModal = () => {
    const { afterAddToHomeScreenClose } = this.props

    this.setState({
      visible: false,
    }, () => {
      if (afterAddToHomeScreenClose && typeof afterAddToHomeScreenClose === 'function') {
        afterAddToHomeScreenClose()
      }
    })
  }

  render() {
    const { visible } = this.state
    const { graphics, brand } = this.props

    const brandColor = brand && brand.hasOwnProperty('brandColor') ? brand.brandColor : null
    const icon = getIconFromGraphics(graphics, 'apple-touch-icon')

    return (
      <Modal
        visible={visible}
        centered
        className={styles.pwaModal}
        closable={false}
        footer={null}
        onOk={this.closeModal}
        onCancel={this.closeModal}
        getContainer={() => getBodyContainer()}
      >
        <div className={styles.pwaModalContent}>
          <div className={styles.iconClose} onClick={this.closeModal}>
            <SvgIcon size="md" type="RemoveThinner" />
          </div>
          <div className={styles.iconContainer}>
            <div className={styles.iconBlank} />
            <div className={styles.iconBlank} />
            <div className={styles.iconKiosk} style={brandColor ? {backgroundColor: brandColor} : {}}>
              <img display-if={icon} src={icon} alt=""/>
            </div>
            <div className={styles.iconBlank} />
            <div className={styles.iconBlank} />
          </div>
          <h2>
            <FormattedMessage
              id="app.addToHomeScreen.install"
              description="Install <brend app name>"
              defaultMessage="Install"
            />
            &nbsp;{brand.name || ''}
          </h2>
          <p>
            <FormattedMessage
              id="app.addToHomeScreen.installDescription"
              defaultMessage="Install this application on your home screen for quick and easy access when you're on the go."
            />
          </p>
        </div>
        <div className={styles.pwaModalFooter}>
          <FormattedMessage
            id="app.addToHomeScreen.installDescription2"
            description="Part of a message `Just tap share <icon> then add to home screen"
            defaultMessage="Just tap"
          />
          <img
            className={styles.pwaModalShareIcon}
            src={require('./share.svg')}
            alt=""
          />
          <FormattedMessage
            id="app.addToHomeScreen.installDescription3"
            description="Part of a message `Just tap share <icon> then add to home screen"
            defaultMessage="then 'Add to Home Screen'"
          />
        </div>
      </Modal>
    )
  }
}

export default AddToHomeScreen
